// extracted by mini-css-extract-plugin
export default {"container":"styles_container__tWDyG","title":"styles_title__fKMuc"};